import React from "react";
import { Paper, Box, Grid, Typography } from "@mui/material";

import DisplaySites from "../DisplaySites";
import Loader from "../Loader";
import { EmptyState } from "../Common";

const SiteList = ({
  isTemplatesSite,
  isAdminTemplates,
  sitesList,
  onManage,
  onEdit,
  onDelete,
}) => {
  const { isLoading, data } = sitesList;
  return (
    <Box sx={{ width: '100%', px: 0 }}>
      {isLoading ? (
        <Paper sx={{ p: 2, borderRadius: 2 }}>
          <Loader text="Loading sites..." />
        </Paper>
      ) : (
        <Box sx={{ px: 0 }}>
          {data.length > 0 ? (
            <DisplaySites
              isAdminTemplates={isAdminTemplates}
              isTemplatesSite={isTemplatesSite}
              data={data}
              onEdit={onEdit}
              onDelete={onDelete}
              onManage={onManage}
            />
          ) : (
            <EmptyState
              title="No sites found"
              description="You haven't added any sites yet. Create a new site to get started."
              actionLabel="Create Site"
            />
          )}
        </Box>
      )}
    </Box>
  );
};

export default SiteList;